module.exports = __webpack_public_path__ + "static/1-e02438129fb247b39d85d01aa4269b60.jpg";